const SSO_SCOPE = 'openid profile email phone address';
// The BH IDP whitelists exact redirect URIs with no query string. Appending
// any query params (e.g. themeVersion for Elevio preview testing) triggers
// `invalid_request` / "Invalid Redirect Uri". Keep the redirect URI bare.
export const getRedirectUrl = (path) => `${window.location.origin}${path}`;
export const buildAuthorizeUrl = ({ ssoBaseUrl, clientId, sid, redirectPath, state, prompt, }) => {
    const params = new URLSearchParams({
        client_id: clientId,
        scope: SSO_SCOPE,
        response_type: 'code',
        sid,
        redirect_uri: getRedirectUrl(redirectPath),
        state,
    });
    if (prompt) {
        params.set('prompt', prompt);
    }
    return `${ssoBaseUrl}/authorize?${params.toString()}`;
};
